import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center p-4">
      <h1 className="display-1 fw-bold" style={{ color: 'var(--brand-color)' }}>404</h1>
      <h4 className="mb-3">Sayfa Bulunamadı</h4>
      <p className="text-muted">Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
      <Link to="/" className="btn btn-brand">Ana Sayfaya Dön</Link>
    </div>
  );
}
